import { defineMessages } from 'react-intl';

export default defineMessages({
    grandprotectLabelUppercase: {
        id: 'ml.gateway.common.mlCoveragePackageLevel.GRANDPROTECT',
        defaultMessage: 'GrandProtect'
    },
    enhancedplusLabelUppercase: {
        id: 'ml.gateway.common.mlCoveragePackageLevel.ENHANCED PLUS',
        defaultMessage: 'Enhanced Plus'
    },
    valueplusLabelUppercase: {
        id: 'ml.gateway.common.mlCoveragePackageLevel.VALUE PLUS',
        defaultMessage: 'Value Plus'
    },
});
